import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { maChybuHrany } from "@/lib/stavHran";
import type { Dielec, Varianta, Zostava } from "@/api/schemas";

/**
 * Pás nad tabuľkou: koľko dielcov má hranu, ktorá dosku neolepí (KOLO 135).
 *
 * Ikona „!" pri dielci je v dlhej zákazke ľahko prehliadnuteľná a zbalená
 * zostava ju schová úplne. Pás povie počet hneď a **Vybrať** ich označí
 * v tabuľke — hromadná úprava ich potom opraví naraz. Tá istá chyba
 * zastaví odoslanie do Cut Rite.
 */
export function PasHran({
  varianta,
  onVyber,
}: {
  varianta: Varianta;
  onVyber: (ids: Set<string>) => void;
}): JSX.Element | null {
  const zle: Dielec[] = [];
  for (const z of (varianta.zostavy ?? []) as Zostava[]) {
    for (const d of (z.dielce ?? []) as Dielec[]) {
      if (maChybuHrany(d)) zle.push(d);
    }
  }
  if (zle.length === 0) return null;

  const kody = zle.map((d) => d.kod).join(", ");
  return (
    <div
      role="status"
      className="flex shrink-0 items-center gap-2 border-b border-destructive/30 bg-destructive/10 px-3 py-1.5 text-xs text-destructive"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate" title={kody}>
        {zle.length === 1
          ? "1 dielec má hranu, ktorá je úzka na hrúbku dosky"
          : `${zle.length} dielce majú hranu, ktorá je úzka na hrúbku dosky`}
        {": "}
        <span className="font-mono">{kody}</span>
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="ml-auto h-6 shrink-0 px-2 text-xs"
        onClick={() => onVyber(new Set(zle.map((d) => d.id)))}
      >
        Vybrať
      </Button>
    </div>
  );
}
